import {combineReducers} from 'redux';

import views from '../views/combined-views-reducer';
import {reduce as settings} from './settings.redux';

export default combineReducers({
  views,
  settings,
});
